module.exports = __webpack_public_path__ + "static/media/logo.577ce152.jpg";